var fluidRange = (function (property, sizes) {
  var start = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 480;
  var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1200;
  var min = sizes[0];
  var max = sizes[1];
  var multiplier = (max - min) / (end - start) * 100;
  var adder = (min * end - max * start) / (end - start);
  return "\n    ".concat(property, ": calc(").concat(multiplier, "vw + ").concat(adder, "px);\n\n    @media (max-width: ").concat(start, "px) {\n      ").concat(property, ": ").concat(min, "px;\n    }\n\n    @media (min-width: ").concat(end, "px) {\n      ").concat(property, ": ").concat(max, "px;\n    }\n  ");
});

export { fluidRange as default };
//# sourceMappingURL=fluidRange.js.map
